const DocumentActionTypes = {
  DOWNLOAD_INVESTMENT_STATEMENT: "DOWNLOAD_INVESTMENT_STATEMENT",
  FETCH_DOCUMENTS_API: "FETCH_DOCUMENTS_API",
};

export default DocumentActionTypes;
